import React, { Component } from 'react';

import { MyInput } from '../elements/MyInput';
import { GhorePrizeTable } from '../tables/ghorePrize/GhorePrizeTable';
import { Dropdown } from '../elements/Dropdown'
import { GhoreKeshiDetail } from '../components/GhoreKeshiDetail';


export class GhorePrizePage extends Component {


  constructor(props) {
    super(props);
    this.state = { isLoading: true };
    this.state.data = {};
    this.state.mode = 1;
    //this.state.data[ghoreId]=this.props.ghoreId;

    //  this.incrementCounter = this.incrementCounter.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);


    //  console.log("ghore prize:"+this.props.ghoreId);



    var token = localStorage.getItem('token');
    this.headers =
    {
            'Content-Type': 'application/json',
            'ghoreId': this.props.ghoreId,
            'AuthorizationToken':token
    };

    this.onGhoreClick = this.onGhoreClick.bind(this);
  }

  onGhoreClick(e, d) {
    //   console.log(e);
    //   console.log(d);

    this.setState({ mode: 2, ghorePrizeId: d });
  }

  componentDidMount() {
    var offset = (this.state.pageNumber - 1) * this.state.pageSize;

    this.setState({ isLoading: true });
    fetch('api/v1/GetAllPrize',
      {
        method: 'GET',
        headers: this.headers
      }).then(res => {
        this.status = res.status;

        res.json().then((result) => {
          //              console.log(result);
          this.state.data2 = result;


          this.setState({ isLoading: false });
          this.setState({});
        },
          (error) => {
            this.setState({ isLoading: false });
          }
        );
      }
      );
  }

  handleSubmit(e) {
    e.preventDefault();


    this.setState({ isLoading: true });
    var data = this.state.data;
    //   console.log("data");
    //   console.log(data);

    fetch('api/v1/AddGhorePrize',
      {
        method: 'POST',
        body: JSON.stringify(data),
        headers: this.headers
      }).then(res => {
        this.status = res.status;

        res.json().then((result) => {
          alert('OK');
          this.setState({ isLoading: false });
          this.setState({});
        },
          (error) => {
            this.setState({ isLoading: false });
          }
        );
      }
      );


  }
  onFormChange() {

  }

  handleTextChange(e, key) {
    //   console.log(e);
    this.state.data[key] = e;
    this.setState({});
  }



  render() {
    if (this.state.isLoading) {
      return <div>...</div>
    }



    if (this.state.mode == 2) {
      return <GhoreKeshiDetail ghorePrizeId={this.state.ghorePrizeId}></GhoreKeshiDetail>
    }

    return (

      <div>


        <br></br>
        <GhorePrizeTable ghoreId={this.props.ghoreId} onGhoreClick={this.onGhoreClick}>

        </GhorePrizeTable>


        <div className="row">

           <div className="col-md-4"></div>
          <div className="col-md-4 col-sm-12">
            <form className="" onSubmit={this.handleSubmit} ref="myRef">
              <Dropdown onChange={this.handleTextChange} Data={this.state.data2} label="نام جایزه" name="prizeId" ></Dropdown>
              <br/>
              <MyInput onChange={this.handleTextChange} label="تعداد" name="count" ></MyInput>
              <br/>
              <MyInput onChange={this.handleTextChange} label="توضیحات" name="description" ></MyInput>
              <br/>
              <button className="btn btn-primary" onClick={this.handleSubmit}>اضافه کردن</button>
              <br/>
            </form>
          </div>
          <div className="col-md-4"></div>
        </div>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GhorePrizePage.js